import { DataObject } from 'src/models/DataObject'
import { Asset } from 'src/models/Asset'
import { DealRoom } from 'src/models/DealRoom'
import { Page } from 'src/models/Page'
import moment from 'moment'
import { getFeedContentData, getFeedContentTargetLink } from 'src/utils/content'
import { sharedDataStore } from 'src/store/DataStore'
import { Submodule } from 'src/models/Submodule'
import { Paths } from 'src/constants/navigation'

export class Template extends DataObject {
  static OVERRIDE_MAPPINGS = {
    learningContent: ({ learningContent: lc }) => (lc ? getFeedContentData(lc.contentData, lc.contentType) : undefined),
    submodule: ({ submodule }) => (submodule ? Submodule.fromData(submodule) : undefined),
  }

  static apiEndpoint: string = '/feed/template/'

  id: string
  name: string
  learningContent?: Asset | DealRoom | Page
  submodule?: Submodule
  templatedContentCount: number = 0

  canEdit = () => sharedDataStore.user.isFaasAdminOrManager()

  createdAt: moment.Moment
  lastUpdated: moment.Moment

  getTitle = () => this.name

  getTagTitle = (config?: { includeFileType?: boolean; showTemplate?: boolean }) => {
    if (this.learningContent) return this.learningContent.getTagTitle(config)
    else if (this.submodule) return this.submodule.getTagTitle(config)
    return ''
  }

  getTargetLink = () => {
    if (this.learningContent) return getFeedContentTargetLink(this.learningContent)
    if (this.submodule) return Paths.getSubmodulePath(this.submodule.courseId, this.submodule.id)
    return '#'
  }

  isLocked = () => false
}
